import { style } from 'typestyle'
export const w80 = style({ width: '80%' })
